import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import ForClients from "./ForClients";
import ForCommunities from "./ForCommunities";
import ForFacilities from "./ForFacilities";
import ForProfessionals from "./ForProfessionals";
import Home from "./Home";
import OnboardingEdinburghPtAcademy from "./OnboardingEdinburghPtAcademy";
import OnboardingTrainingProvider from "./OnboardingTrainingProvider";
import OurStory from "./OurStory";
import PreRegister from "./PreRegister";
import PreRegisterCommunity from "./PreRegisterCommunity";
import PreRegisterFacility from "./PreRegisterFacility";
import PrivacyPolicy from "./PrivacyPolicy";
import SocialCard from "./SocialCard";
import TrainingProviders from "./TrainingProviders";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/professionals" element={<ForProfessionals />} />
        <Route path="/clients" element={<ForClients />} />
        <Route path="/facilities" element={<ForFacilities />} />
        <Route path="/communities" element={<ForCommunities />} />
        <Route path="/training-providers" element={<TrainingProviders />} />
        <Route
          path="/onboarding-training-provider"
          element={<OnboardingTrainingProvider />}
        />
        <Route
          path="/onboarding-edinburgh-pt-academy"
          element={<OnboardingEdinburghPtAcademy />}
        />
        <Route path="/preregister" element={<PreRegister />} />
        <Route path="/preregister-facility" element={<PreRegisterFacility />} />
        <Route path="/preregister-community" element={<PreRegisterCommunity />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/socialcard" element={<SocialCard />} />
        <Route path="/social-card" element={<SocialCard />} />
      </Routes>
    </Router>
  );
}

export default App;
